/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const removeSpecialChar = (string) => {
    if (string) {
        const cleanedStr = string
            .replace(/<[^>]*>/g, ' ')        // Remove all HTML tags
            .replace(/\n/g, ' ')             // Remove newline characters
            .replace(/[^a-zA-Z0-9 ]/g, ' ')  // Remove special characters (keep letters, numbers, spaces)
            .replace(/\s+/g, ' ')            // Normalize multiple spaces
            .trim();                         // Remove leading/trailing spaces

        return cleanedStr.toLowerCase();     // Convert to lowercase
    }
    return string;
};

export default removeSpecialChar;
